import { render, staticRenderFns } from "./MyEvaluationsComponent.vue?vue&type=template&id=cb8fbc84&scoped=true"
import script from "./MyEvaluationsComponent.vue?vue&type=script&lang=js"
export * from "./MyEvaluationsComponent.vue?vue&type=script&lang=js"
import style0 from "./MyEvaluationsComponent.vue?vue&type=style&index=0&id=cb8fbc84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8fbc84",
  null
  
)

export default component.exports